// extracted by css-extract-rspack-plugin
module.exports =  {"bubbleContainer":"DepartingMessageBubble__bubbleContainer___v4qkT","bubble":"DepartingMessageBubble__bubble___IcSuZ","content":"DepartingMessageBubble__content___clbRU"};